import { Component, OnInit } from '@angular/core';
import { AccordionCategory, AccordionItem } from '../../../shared/widgets/accordion/accordion.component';
import { DialogsService } from '../../../services/dialogs.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {
reports: AccordionCategory[] = [
      {
        title: 'Favorites',
        isOpen: true,
        items: []
      },
      {
        title: 'Business overview',
        isOpen: true,
        items: [
          { name: 'Clients Map Locations', icon: 'document_text', favorite: true, report_url: '/dashboard/reports/clients-map-locations' },
          { name: 'Oil Collection Summary', icon: 'document_text', favorite: false, report_url: '/dashboard/reports/oil-collection-summary' },
          { name: 'Clients QR Codes', icon: 'document_text', favorite: true, onClick: () => this.openQRModalReport() },
          { name: 'Custom Report Builder', icon: 'document_text', favorite: false, report_url: '/dashboard/reports/custom-report' },
          { name: 'Client Financial Analysis', icon: 'document_text', favorite: false, report_url: '/dashboard/reports/financial-analysis' }
        ]
      }
    ];
  constructor(
    private dialogsService: DialogsService,
  ) { }

  ngOnInit(): void {
    this.loadFavoritesFromStorage();
  }

  // Manejar el evento cuando se cambia el estado de favorito
  onFavoriteToggled(item: AccordionItem): void {
    this.updateFavoritesList();
  }

  // Actualizar la lista de favoritos basada en todos los elementos marcados como favoritos
  private updateFavoritesList(): void {
    const allFavorites: AccordionItem[] = [];
    
    // Recopilar todos los elementos marcados como favoritos de todas las categorías
    this.reports.forEach(category => {
      if (category.title !== 'Favorites') {
        category.items.forEach(item => {
          if (item.favorite) {
            allFavorites.push({ ...item });
          }
        });
      }
    });
    
    // Actualizar la categoría de favoritos
    const favoritesCategory = this.reports.find(cat => cat.title === 'Favorites');
    if (favoritesCategory) {
      favoritesCategory.items = allFavorites;
    }
  }

  // Cargar el estado de favoritos desde localStorage al inicializar
  private loadFavoritesFromStorage(): void {
    const stored = localStorage.getItem('accordion-favorites');
    if (stored) {
      const storedFavorites: AccordionItem[] = JSON.parse(stored);
      
      // Actualizar el estado de favoritos en todas las categorías
      this.reports.forEach(category => {
        category.items.forEach(item => {
          const isFavorite = storedFavorites.some(fav => fav.name === item.name);
          item.favorite = isFavorite;
        });
      });
      
      // Actualizar la lista de favoritos
      this.updateFavoritesList();
    }
  }

  openQRModalReport() {
    this.dialogsService.openCreateQrCodesModal();
  }

}
